/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentDetailsProductViewModel } from './InvestmentDetailsProductViewModel';
import {
    InvestmentDetailsProductViewModelFromJSON,
    InvestmentDetailsProductViewModelFromJSONTyped,
    InvestmentDetailsProductViewModelToJSON,
} from './InvestmentDetailsProductViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfInvestmentDetailsProductViewModel
 */
export interface ResultOfInvestmentDetailsProductViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {InvestmentDetailsProductViewModel}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    data?: InvestmentDetailsProductViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfInvestmentDetailsProductViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfInvestmentDetailsProductViewModel interface.
 */
export function instanceOfResultOfInvestmentDetailsProductViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfInvestmentDetailsProductViewModelFromJSON(json: any): ResultOfInvestmentDetailsProductViewModel {
    return ResultOfInvestmentDetailsProductViewModelFromJSONTyped(json, false);
}

export function ResultOfInvestmentDetailsProductViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfInvestmentDetailsProductViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : InvestmentDetailsProductViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfInvestmentDetailsProductViewModelToJSON(value?: ResultOfInvestmentDetailsProductViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': InvestmentDetailsProductViewModelToJSON(value.data),
        'Count': value.count,
    };
}

